<template>
  <v-switch
    v-model="closedFilter"
    :label="$t('chat.filterClosed')"
    data-testid="sms-context-menu-closed"
  ></v-switch>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'chat-closedFilter',
  computed: {
    ...mapGetters({
      closed: 'chat/SmsFilters/closed'
    }),
    closedFilter: {
      get () { return this.closed },
      set (closed) { this.setClosed(closed) }
    }
  },
  methods: {
    ...mapActions({
      setClosed: 'chat/SmsFilters/filterClosed'
    })
  }
}
</script>

<style>

</style>
